import { Button, Text, HStack, VStack, Icon } from "@chakra-ui/react";
import { formatPlate } from "../../utils/formatPlate";
import { getTipoCarga } from "../../utils/getTipoCarga";
import { extractItens } from "./extractItens";
import _ from "underscore";
import { faTruck, faUser, faWeight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const ShippingItem: React.FC<{
  carga: Record<string, any>;
  onClick: () => void;
}> = ({ carga, onClick }) => {
  const plateFormated = carga.ff08
    ? formatPlate(carga.ff08.FF08_001_C.trim())
    : "SEM PLACA";
  const jaCarregando = !!carga.k19;
  const itens = extractItens(carga);
  const qtdFaltando = _.reduce(itens, (a, n) => a + n.qtd - n.read, 0);
  const cor = !jaCarregando ? "blue" : qtdFaltando > 0 ? "red" : "green";

  return (
    <Button
      py="0.6rem"
      px="0.3rem"
      border="1px"
      variant="solid"
      colorScheme={cor}
      display="flex"
      flexDirection="column"
      textAlign="left"
      alignItems="start"
      h="auto"
      onClick={onClick}
      my="0.1rem"
      w="100%"
    >
      <Text fontSize="lg" fontWeight="bold" mb={2}>
        {plateFormated} - Agrupamento {carga.N01_001_C}
      </Text>
      
      <VStack spacing={2} align="stretch" w="100%">
        <HStack>
          <FontAwesomeIcon icon={faTruck} />
          <Text>Tipo carga: {getTipoCarga(carga)}</Text>
        </HStack>
        
        <HStack>
          <FontAwesomeIcon icon={faUser} />
          <Text noOfLines={1}>Motorista: {carga.a03?.A03_003_C || "Não identificado"}</Text>
        </HStack>
        
        <HStack>
          <FontAwesomeIcon icon={faWeight} />
          <Text>Peso Tara: {carga.N01_007_N}</Text>
        </HStack>
      </VStack>
    </Button>
  );
};
